var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimestream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2752 17.1199C14.3104 17.1199 9.63843 15.1999 9.63843 12.6847C9.63843 10.1695 14.3104 8.24951 20.2752 8.24951C26.24 8.24951 30.912 10.1695 30.912 12.6847C30.912 15.1999 26.24 17.1199 20.2752 17.1199ZM20.2752 9.20951C14.5728 9.20951 10.5984 11.0399 10.5984 12.6847C10.5984 14.3295 14.5728 16.1599 20.2752 16.1599C25.9776 16.1599 29.952 14.3295 29.952 12.6847C29.952 11.0399 25.9776 9.20951 20.2752 9.20951Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.912 12.6851H29.952V20.2563H30.912V12.6851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2752 39.7507C14.3104 39.7507 9.63843 37.8307 9.63843 35.3155V12.6851H10.5984V35.3155C10.5984 36.9603 14.5728 38.7907 20.2752 38.7907C25.9776 38.7907 29.952 36.9603 29.952 35.3155V33.1523H30.912V35.3155C30.912 37.8051 26.24 39.7507 20.2752 39.7507Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3008 25.0368C14.3488 25.0368 9.68958 23.1168 9.68958 20.5952H10.6496C10.6496 22.24 14.6112 24.0768 20.3008 24.0768C21.2459 24.0758 22.1903 24.0224 23.1296 23.9168L23.2384 24.8704C22.2631 24.9813 21.2823 25.0369 20.3008 25.0368V25.0368Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3008 32.8127C14.3488 32.8127 9.68958 30.8607 9.68958 28.3711H10.6496C10.6496 30.0159 14.6112 31.8527 20.3008 31.8527C21.2459 31.8506 22.1902 31.7972 23.1296 31.6927L23.232 32.6399C22.2589 32.752 21.2803 32.8097 20.3008 32.8127V32.8127Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6193 32.7102H24.5761C24.5128 32.7111 24.45 32.6992 24.3914 32.6754C24.3328 32.6516 24.2795 32.6163 24.2348 32.5715C24.19 32.5268 24.1547 32.4735 24.1309 32.4149C24.1071 32.3563 24.0953 32.2935 24.0961 32.2302V19.7246H25.0561V31.7502H37.6193V32.7102Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0285 27.8907L25.6301 29.2891L26.3089 29.9679L27.7073 28.5695L27.0285 27.8907Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1072 27.1743L28.4288 26.4959L29.7344 25.1839H32.992L37.28 20.9023L37.9584 21.5807L33.3952 26.1439H30.1312L29.1072 27.1743Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1632 23.7821L28.5696 22.1885H25.7408V21.2285H28.9664L30.1632 22.4253L31.3664 21.2285H32.928L34.7008 23.0013L34.0224 23.6797L32.5312 22.1885H31.7632L30.1632 23.7821Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8647 24.1659L35.1859 24.8447L37.2812 26.94L37.96 26.2612L35.8647 24.1659Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6912 31.0014L36.0128 30.323L36.9408 29.395L36.0128 28.467L36.6912 27.7886L38.2976 29.395L36.6912 31.0014Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4001 30.5406L25.6321 25.7726L26.3105 25.0942L30.4001 29.1838L32.2625 27.3214L33.8561 28.915H37.6193V29.875H33.4593L32.2625 28.6782L30.4001 30.5406Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3616 27.3535H36.0896V26.3935H37.4016V25.0815H38.3616V27.3535Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3616 22.6045H37.4016V21.2925H36.0896V20.3325H38.3616V22.6045Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -9.9456,
    y1: 57.9456,
    x2: 57.9392,
    y2: -9.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestream);
export default __webpack_public_path__ + "static/media/Timestream.7d5411c9.svg";
export { ForwardRef as ReactComponent };